<script lang="ts">
	// The site's footer. The designs also draw contact details, marked as
	// placeholders there; they come back when real ones exist (decided
	// 2026-10-03). Of the legal links, only the privacy page exists so far.

	import BrandMark from '../components/BrandMark.svelte';
	import { brand, footer, nav, tagline } from './copy';

	const links = [
		{ href: '/#reports', label: nav.reports, testId: 'site-footer-reports' },
		{ href: '/#summaries', label: nav.summaries, testId: 'site-footer-summaries' },
		{ href: '/#orders', label: nav.orders, testId: 'site-footer-orders' },
		{ href: '/pricing', label: nav.pricing, testId: 'site-footer-pricing' },
		{ href: '/#faq', label: nav.faq, testId: 'site-footer-faq' },
	];

	const legal = [{ href: '/privacy', label: nav.privacy, testId: 'site-footer-privacy' }];
</script>

<footer class="footer">
	<div>
		<a class="brand" href="/" aria-label={nav.home} data-testid="site-footer-home">
			<BrandMark />
			<span class="name">{brand}</span>
		</a>
		<p class="tagline">{tagline}</p>
	</div>
	<div>
		<p class="heading">{footer.pages}</p>
		<div class="links">
			{#each links as link (link.testId)}
				<a href={link.href} data-testid={link.testId}>{link.label}</a>
			{/each}
		</div>
	</div>
	<div>
		<p class="heading">{footer.legal}</p>
		<div class="links">
			{#each legal as link (link.testId)}
				<a href={link.href} data-testid={link.testId}>{link.label}</a>
			{/each}
		</div>
	</div>
</footer>

<style>
	.footer {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
		gap: var(--space-10);
		padding-block: var(--space-11) 40px;
		border-block-start: var(--border-width) solid var(--border-default);
	}

	.brand {
		display: flex;
		align-items: center;
		gap: var(--space-3);
		margin-block-end: var(--space-3);
		color: var(--text-strong);
		text-decoration: none;
	}

	.name {
		font-size: var(--text-h4);
		font-weight: var(--weight-bold);
		letter-spacing: var(--tracking-snug);
	}

	.tagline {
		margin: 0;
		font-size: var(--text-2xs);
		line-height: 1.7;
		color: var(--text-muted);
	}

	.heading {
		margin: 0 0 var(--space-3);
		font-size: var(--text-2xs);
		font-weight: var(--weight-semibold);
		color: var(--text-muted);
	}

	.links {
		display: flex;
		flex-direction: column;
		gap: var(--space-2);
		font-size: var(--text-xs);
	}

	.links a {
		color: var(--text-body);
		white-space: nowrap;
	}
</style>
